export default "__VITE_ASSET__DBV$6Qix__"